import {
    Fragment,
    RefObject, useEffect, useState,
} from 'react';

import styles from './styles.module.scss';

interface Props {
    containerRef: RefObject<HTMLDivElement|null>;
  containerHeight: number;
}

const THUMB_HEIGHT = 70;

function ScrollBar({ containerRef, containerHeight }:Props) {
    // const [containerHeight, setContainerHeight] = useState(0);
    const [transform, setTransform] = useState<number>(0);
    const [isVisible, setIsVisible] = useState<boolean>(false);
    useEffect(() => {
        const onScroll = () => {
            const { scrollHeight, offsetHeight, scrollTop } = containerRef.current!;
            const percent = (scrollTop) / (scrollHeight - offsetHeight);
            setTransform(percent * (containerHeight - THUMB_HEIGHT * 1.5));
            setIsVisible(scrollHeight > offsetHeight);
        };
        if (containerRef.current) {
            // setContainerHeight(containerRef.current.offsetHeight);
            containerRef.current.addEventListener('scroll', onScroll);
        }
        onScroll();
        return () => containerRef.current?.removeEventListener('scroll', onScroll);
    }, [containerRef, containerHeight]);
    /*
  useEffect(() => {
    const onResize = () => {
      if (containerRef.current) {
        setContainerHeight(containerRef.current.offsetHeight);
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    containerRef.current?.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      containerRef.current?.removeEventListener('resize', onResize);
    };
  }, [containerRef]);

   */
    if (isVisible) {
        return (
            <div className={styles.scrollbar}>
                <div className={styles.scrollbarThumb}
                    style={{ transform: `translateY(${transform}px)` }}
                />
            </div>
        );
    }
    return <Fragment/>;
}

export default ScrollBar;
